import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
export var DropzoneLoader = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DropzoneLoader, _React$PureComponent);
  var _super = _createSuper(DropzoneLoader);
  function DropzoneLoader() {
    var _this;
    _classCallCheck(this, DropzoneLoader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      Dropzone: DropzoneLoader.Dropzone,
      MediaPickerErrorBoundary: DropzoneLoader.MediaPickerErrorBoundary
    });
    return _this;
  }
  _createClass(DropzoneLoader, [{
    key: "UNSAFE_componentWillMount",
    value: function () {
      var _UNSAFE_componentWillMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!this.state.Dropzone || !this.state.MediaPickerErrorBoundary)) {
                _context.next = 16;
                break;
              }
              _context.prev = 1;
              _context.next = 4;
              return Promise.all([import( /* webpackChunkName: "@atlaskit-internal_media-client" */'@atlaskit/media-client'), import( /* webpackChunkName: "@atlaskit-internal_media-dropzone" */'./dropzone'), import( /* webpackChunkName: "@atlaskit-internal_media-picker-error-boundary" */'../media-picker-analytics-error-boundary')]);
            case 4:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              mediaClient = _yield$Promise$all2[0];
              dropzoneModule = _yield$Promise$all2[1];
              mediaPickerErrorBoundaryModule = _yield$Promise$all2[2];
              DropzoneLoader.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone, this.props.featureFlags);
              DropzoneLoader.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
              this.setState({
                Dropzone: DropzoneLoader.Dropzone,
                MediaPickerErrorBoundary: DropzoneLoader.MediaPickerErrorBoundary
              });
              _context.next = 16;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 14]]);
      }));
      function UNSAFE_componentWillMount() {
        return _UNSAFE_componentWillMount.apply(this, arguments);
      }
      return UNSAFE_componentWillMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        Dropzone = _this$state.Dropzone,
        MediaPickerErrorBoundary = _this$state.MediaPickerErrorBoundary;
      if (!Dropzone || !MediaPickerErrorBoundary) {
        return null;
      }
      return /*#__PURE__*/React.createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/React.createElement(Dropzone, this.props));
    }
  }]);
  return DropzoneLoader;
}(React.PureComponent);
_defineProperty(DropzoneLoader, "displayName", 'AsyncDropzone');